<!--胃镜-->
<script setup>
import { ref,computed, reactive,watch } from "vue";
import { useCrfStore } from "@/stores/crf";
const crfStore = useCrfStore();
import {useCommonStore} from "@/stores/common.js"
// 定义组件props属性
const props = defineProps({
  formModel: {},
  type: null
});

// console.log(props.formModel.fields)

const model = reactive(props.formModel);
watch(()=>model.fields[`${props.type}`]?.['转归'], (newVal, oldVal) => {
    // console.log(newVal,"newVal")
    if(newVal[newVal.length-1] == '死亡' && newVal.length != 1){
        model.fields[`${props.type}`]['转归'] = ['死亡']
    }
})

// 节省代码长度，在模板中使用
const crfFields = computed(() => {
  return model.fields[`${props.type}`];
});

// 字段自动校验用于赋值 prop
const itemProp = function(prop) {
  return `fields['${props.type}']['${prop}']`;
};

</script>
<template>
  <!-- V0期（筛选期）不显示转归内容 -->
  <template v-if="crfFields">
    <div style="display:flex;">
      <div class="wj_title">
        <h2>转归</h2>
      </div>
    </div>
            <el-form-item label="转归" :prop="itemProp('转归')"  class="redStar">
                  <el-checkbox-group  v-model="crfFields['转归']">
                      <el-checkbox label="腹水" prop="腹水"  :disabled=" /死亡/ig.test(crfFields['转归']?.join())"></el-checkbox>
                      <el-checkbox label="肝性脑病" prop="肝性脑病"  :disabled=" /死亡/ig.test(crfFields['转归']?.join())"></el-checkbox>
                      <el-checkbox label="死亡" prop="死亡"></el-checkbox>
                      <el-checkbox label="其他" prop="其他" :disabled=" /死亡/ig.test(crfFields['转归']?.join())"></el-checkbox>
                  </el-checkbox-group>
            </el-form-item>
            
            <!-- 说明内容 -->
            <el-form-item v-if="crfFields['转归'] && crfFields['转归'].length > 0 && props.type !== 'V0肝穿点±2周'" label="说明内容">
              <el-input 
                v-model="crfFields['说明内容']" 
                type="textarea"
                :rows="3"
                placeholder="请输入具体信息">
              </el-input>
            </el-form-item>
            </template>

</template>

<style lang="scss" scoped>
.wj_title{
  margin-bottom: 10px;
  p{
    margin:0;
    color:rgba(229, 26, 26, 0.8);
    font-size:12px;
  }
}
</style>